<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-date-picker
                        v-model="datetimerange"
                        type="datetimerange"
                        start-placeholder="取消时间"
                        end-placeholder="取消时间"
                        class="fl"
                        size="small"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        unlink-panels
                        >
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/goodsRefund/export')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading">导出日志</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="orderSn" label="订单编号" min-width="140"></el-table-column>
                <el-table-column prop="goodsName" label="商品名称" show-overflow-tooltip min-width="250">
                    <template slot-scope="scope">
                        {{scope.row.goodsName}}
                    </template>
                </el-table-column>
                <el-table-column prop="skuDesc" label="SKU" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="状态">
                    <template slot-scope="scope">
                       {{refundStatus.get(scope.row.refundStatus)}}
                    </template>
                </el-table-column>
                <el-table-column prop="refundNum" label="数量"></el-table-column>
                <el-table-column prop="returnTime" label="取消时间" min-width="150"></el-table-column>
                <el-table-column prop="refundTime" label="退款时间" min-width="150"></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo:1,
    startTime:'',
    endTime:''
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            datetimerange:[],
            params:{
                ...defaultParams,
                pageSize:this.$pageSizes[0],
            },
            listLoading: true,
            downLoading: false
        }
    },
    computed:{
        refundStatus(){
            return new Map([
                [1,'待退款'],[2,'退款中'],[3,'退款成功'],[4,'退款失败']
            ])
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/goodsRefund/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出日志
        async download(){
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/goodsRefund/export',
                method: 'post',
                data: {
                    // ...this.params,
                    startTime:this.datetimerange && this.datetimerange[0] || '',
                    endTime:this.datetimerange && this.datetimerange[1] || ''
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'商品退款日志.'+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
    }
}
</script>